import style from "./style.scss";
import { mergeClasses } from "../../helpers";

const Menu = ({ open = false }) => (
  <span class={mergeClasses([style.menu, open ? style.open : null])}>
    <span class={style.wrapper}>
      <span class={style.line} />
      <span class={style.line} />
      <span class={style.line} />
    </span>
  </span>
);

export default Menu;
